import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-wide footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "footer__separator" }, null, -1)
const _hoisted_3 = { class: "footer__menu" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Moscow Patriots", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "footer__separator" }, null, -1)
const _hoisted_6 = { class: "footer__container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "footer__container__text" }, "© 2024 Moscow Patriots, All Rights Reserved", -1)
const _hoisted_8 = { class: "footer__container__icons" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]

import {reactive} from "vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import VKIcon from "@/components/icons/VKIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const data = reactive({
  links: {
    // x: "https://x.com/Footballer_MU",
    instagram: "https://instagram.com/moscowpatriotsofficial",
    vk: "https://vk.com/moscowpatriots"
    // linkedin: "https://linkedin.com/in/kirill-kobunov",
    // telegram: "https://t.me/methodius84"
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("nav", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          href: data.links.instagram,
          target: "_blank"
        }, [
          _createVNode(InstagramIcon, { color: '#2c3e50' })
        ], 8, _hoisted_9),
        _createElementVNode("a", {
          href: data.links.vk
        }, [
          _createVNode(VKIcon, { color: '#2c3e50' })
        ], 8, _hoisted_10)
      ])
    ])
  ]))
}
}

})